import api from "./api";
import { PriceType } from "../components/References/priceScheme/priceType";
export type DeletPriceSchemeDto = {
  id: number | string;
};


/*Search & filter */
export const getPriceSchemeApi = async (body: {
  limit: number;
  q: string;
  isActive?: boolean;
}) => {
  let url = `/priceSchemes?limit=${body.limit}&q=${body.q.toString()}`;

  if (body.isActive !== undefined) {
    url += `&isActive=${body.isActive}`;
  }

  return await api.get(url);
};


export const getPriceScheme = async () => {
  return await api.get("/priceSchemes");
};

export const deletePriceScheme = async (dto: DeletPriceSchemeDto) => {
  return await api.delete(`/priceSchemes/${dto.id}`);
};
export const getPriceSchemeById = async (
  priceSchemesId: string | undefined
) => {
  return await api.get(`/priceSchemes/${priceSchemesId}`);
};

export const createPriceScheme = async (priceSchemesDetails: PriceType) => {
  return await api.post("/priceSchemes", priceSchemesDetails);
};
export const editPriceScheme = async (priceSchemesId: any, body: PriceType) => {
  return await api.put(`/priceSchemes/${priceSchemesId}`, body);
};


export const getPriceSchemeDropdown = async () => {
  return await api.get("/priceSchemes/dropdown");
};
